import { isNil, tryGetValue } from '../../utils';

import { Type } from '../interfaces/type.interface';

import { SerializableObject } from './serializable-object';

// TODO: Define proper type for stats.
export type PagedResultsStats = any;

/** PagedResults wrapper for list of serializable objects. */
export class PagedResults<T extends SerializableObject> extends SerializableObject {
  public results: T[];
  public currentPage: number;
  public pageSize: number;
  public totalCount: number;
  public totalPageCount: number;
  public stats: PagedResultsStats;
  private readonly type: Type<T>;

  constructor(type: Type<T>) {
    super();
    this.type = type;
  }

  // TODO: #8284 This method should be called after `this.type` has been initialized.
  public buildFromJSON(json: object): void {
    if (isNil(json)) {
      return;
    }

    this.results = [];

    const collection = tryGetValue<object[]>(json, 'results');
    if (Array.isArray(collection)) {
      collection.forEach((itemJson: object): void => {
        const resultItem: T = new this.type();
        resultItem.buildFromJSON(itemJson);
        this.results.push(resultItem);
      });
    }

    this.currentPage = tryGetValue<number>(json, 'currentPage', undefined) || 0;
    this.pageSize = tryGetValue<number>(json, 'pageSize', undefined) || 0;
    this.totalCount = tryGetValue<number>(json, 'totalCount', undefined) || 0;
    this.totalPageCount = tryGetValue<number>(json, 'totalPageCount', undefined) || 0;
    this.stats = tryGetValue<PagedResultsStats>(json, 'stats', undefined);
  }

}
